<template>
  <div class="container">
    <div class="header-wrapper">
      <img class="logo" src="/imgs/logo.png" />
      <div class="search-wrapper">
        <div class="oa-wrapper">
          <el-dropdown style="margin-top: 3px">
            <span class="el-dropdown-link">
              川煤OA系统<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a href="http://192.168.1.80" target="_blank">OA内网</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a href="https://vpn.cmjt.com.cn/" target="_blank">OA外网</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="line"></span>
          <a href="http://125.64.218.31:33150/seeyon/main.do?method=main">协同办公系统</a>
        </div>
        <div class="search">
          <el-input size="small" v-model="searchWords" placeholder="请输入关键词" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="onSearchClick"></el-button>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalHeader',
  data () {
    return {
      searchWords: ''
    }
  },
  methods: {
    onSearchClick () {
      this.$emit('search-click', this.searchWords)
    }
  }
}
</script>

<style scoped>
a {
  color: #666666;
  text-decoration: none;
}

.container {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-wrapper {
  height: 100%;
  width: 1290px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-dropdown-link {
  cursor: pointer;
}

.logo {
  margin-top: 10px;
  height: 60px;
}

.search-wrapper {
  height: 80%;
  width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.oa-wrapper {
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.line {
  height: 20px;
  width: 1px;
  background-color: #999999;
}

.search {
  flex: 1;
}

</style>
